import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getPrinters } from '../../../../../api'
import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../../../constants/common'
import { checkEmailForReply } from '../../../Email.utils'
import { EmailFormContext } from '../../../EmailForm.context'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_DELETE_EMPTY_EMAIL_USERS,
  EMAIL_CREATION_FORM_FIELD_NAME_HAS_NO_EMAIL_ACCOUNTS,
  EMAIL_CREATION_FORM_FIELD_NAME_PRINTER,
  EMAIL_CREATION_FORM_NOTIFICATION_HAS_NO_EMAIL_ACCOUNTS,
} from '../../EmailCreationForm.constants'
import { getEmailFormFlattenRecipients } from '../../EmailCreationForm.utils'
import { EmailPrinterNotificationActions } from '../../EmailPrinterNotificationActions'
import { SelectPrinterModal } from '../../SelectPrinterModal'

import { ACCOUNTS_FIELDS } from './usePrinterForNoEmailAccounts.constants'
import { filterNoEmailAccounts } from './usePrinterForNoEmailAccounts.utils'

export function usePrinterForNoEmailAccounts({
  removeNotification,
  setNotification,
}) {
  const { t } = useTranslation()
  const { setFieldValue, values } = useFormikContext()

  const formContext = useContext(EmailFormContext)

  const [printers, setPrinters] = useState(EMPTY_LIST)

  const accountsNoEmails = values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]?.email
    ? EMPTY_LIST
    : getEmailFormFlattenRecipients(values)
        .filter(i => !checkEmailForReply(i.email) && i.value)
        .map(i => i.value)

  useEffect(() => {
    getPrinters().then(({ data }) => {
      setPrinters(data.results.objects)
    })
  }, [])

  function handleSubmit(value) {
    setFieldValue(
      EMAIL_CREATION_FORM_FIELD_NAME_PRINTER,
      value[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]
    )

    formContext.onCloseModal()
  }

  function handleSendToPrinter() {
    formContext.setModal(
      <SelectPrinterModal
        initialValues={{
          [EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]: printers[0],
        }}
        options={printers}
        onClose={formContext.onCloseModal}
        onSubmit={handleSubmit}
      />
    )
  }

  function handleRemoveAccounts() {
    ACCOUNTS_FIELDS.forEach(fieldName => {
      setFieldValue(
        fieldName,
        filterNoEmailAccounts(values[fieldName], accountsNoEmails)
      )
    })

    setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_DELETE_EMPTY_EMAIL_USERS, true)
  }

  useEffect(() => {
    if (
      !values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER] &&
      accountsNoEmails.length > 0
    ) {
      const canSendToPrinter = printers.length > 0

      setNotification({
        id: EMAIL_CREATION_FORM_NOTIFICATION_HAS_NO_EMAIL_ACCOUNTS,
        linkProps: {
          Component: EmailPrinterNotificationActions,
          canSendToPrinter,
          onRemoveAccounts: handleRemoveAccounts,
          onSendToPrinter: handleSendToPrinter,
        },
        text: t(
          canSendToPrinter
            ? 'Form.SendToPrinterOrRemoveErrorKey'
            : 'Form.IgnoreNoEmailUsersKey'
        ),
        type: NOTIFICATION_TYPE.error,
      })

      setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_HAS_NO_EMAIL_ACCOUNTS, true)
    } else {
      removeNotification(EMAIL_CREATION_FORM_NOTIFICATION_HAS_NO_EMAIL_ACCOUNTS)

      setFieldValue(EMAIL_CREATION_FORM_FIELD_NAME_HAS_NO_EMAIL_ACCOUNTS, false)
    }
  }, [
    accountsNoEmails,
    printers,
    values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER],
  ])

  return { accountsNoEmails, printers }
}
